import type { ReactNode } from 'react'
import { cn } from '~/shared/lib/utils'
import { Label } from '~/shared/ui/label'
import { Switch } from '~/shared/ui/switch'

export function SettingRow({
  id,
  label,
  hint,
  control,
  className,
  children,
}: {
  id?: string
  label: ReactNode
  hint?: ReactNode
  control: ReactNode
  className?: string
  children?: ReactNode
}) {
  return (
    <div className={cn('py-2.5', className)}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 space-y-0.5">
          <Label htmlFor={id} className="leading-snug">
            {label}
          </Label>
          {hint ? <p className="text-muted-foreground text-xs leading-snug">{hint}</p> : null}
        </div>
        <div className="shrink-0">{control}</div>
      </div>
      {children ? <div className="mt-2">{children}</div> : null}
    </div>
  )
}

export function SwitchRow({
  id,
  label,
  hint,
  checked,
  onCheckedChange,
  disabled,
  className,
  children,
}: {
  id: string
  label: ReactNode
  hint?: ReactNode
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
  children?: ReactNode
}) {
  return (
    <SettingRow
      id={id}
      label={label}
      hint={hint}
      className={className}
      control={
        <Switch
          id={id}
          checked={checked}
          disabled={disabled}
          onCheckedChange={(next) => onCheckedChange(next === true)}
        />
      }
    >
      {checked ? children : null}
    </SettingRow>
  )
}
